import { render } from "./expert-card.vue?vue&type=template&id=466c184f"
import script from "./expert-card.vue?vue&type=script&lang=js"
export * from "./expert-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__